import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { Button } from "../../components/ui/button";
import { Badge } from "../../components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { adminApi } from "../../lib/adminApi";
import { toast } from "sonner";

export default function Generations() {
  const [generations, setGenerations] = useState([]);
  const [stats, setStats] = useState(null);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [gensData, statsData] = await Promise.all([
        adminApi.getGenerations({ page, limit: 20 }),
        adminApi.getGenerationStats()
      ]);
      setGenerations(gensData.data);
      setTotal(gensData.total);
      setStats(statsData);
    } catch (e) {
      toast.error(e.message);
    }
    setLoading(false);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchData(); }, [page]);

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Generations</h1>

      {stats && (
        <div className="grid grid-cols-4 gap-4 mb-6">
          <Card>
            <CardHeader className="pb-2"><CardTitle className="text-sm">Total</CardTitle></CardHeader>
            <CardContent><div className="text-2xl font-bold">{stats.total}</div></CardContent>
          </Card>
          <Card>
            <CardHeader className="pb-2"><CardTitle className="text-sm">Successful</CardTitle></CardHeader>
            <CardContent><div className="text-2xl font-bold text-green-600">{stats.successful}</div></CardContent>
          </Card>
          <Card>
            <CardHeader className="pb-2"><CardTitle className="text-sm">Failed</CardTitle></CardHeader>
            <CardContent><div className="text-2xl font-bold text-red-600">{stats.failed}</div></CardContent>
          </Card>
          <Card>
            <CardHeader className="pb-2"><CardTitle className="text-sm">Avg Duration</CardTitle></CardHeader>
            <CardContent><div className="text-2xl font-bold">{(stats.avg_duration_ms / 1000).toFixed(1)}s</div></CardContent>
          </Card>
        </div>
      )}

      {loading ? (
        <div className="text-center py-8">Loading...</div>
      ) : (
        <>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>ID</TableHead>
                <TableHead>Store</TableHead>
                <TableHead>Model</TableHead>
                <TableHead>Duration</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Created</TableHead>
                <TableHead>Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {generations.map((gen) => (
                <TableRow key={gen.id}>
                  <TableCell>{gen.id}</TableCell>
                  <TableCell className="font-mono text-sm">{gen.store_id || "-"}</TableCell>
                  <TableCell>{gen.model}</TableCell>
                  <TableCell>{gen.duration_ms ? `${(gen.duration_ms / 1000).toFixed(1)}s` : "-"}</TableCell>
                  <TableCell>
                    <Badge variant={gen.success ? "default" : "destructive"}>
                      {gen.success ? "Success" : "Failed"}
                    </Badge>
                  </TableCell>
                  <TableCell>{new Date(gen.created_at).toLocaleString()}</TableCell>
                  <TableCell>
                    <Link to={`/admin/generations/${gen.id}`}>
                      <Button variant="outline" size="sm">View</Button>
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <div className="flex justify-center gap-2 mt-4">
            <Button variant="outline" disabled={page === 1} onClick={() => setPage(page - 1)}>
              Previous
            </Button>
            <span className="py-2 px-4">Page {page} ({total} total)</span>
            <Button variant="outline" disabled={generations.length < 20} onClick={() => setPage(page + 1)}>
              Next
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
